export const zh = {
  title: 'GLAD-Landsat 森林砍伐警报 (GLAD-L)',
  subtitle: '（每周，30m，热带，UMD/GLAD）',
  download_data: 'http://glad-forest-alert.appspot.com/',
  content: [
    {
      label: '功能',
      value: '近乎实时地识别可能出现树木覆盖损失的区域',
    },
    {
      label: '分辨率',
      value: '30×30米',
    },
    {
      label: '地理覆盖范围',
      value: '北纬30度至南纬30度',
    },
    {
      label: '来源',
      value:
        '汉森，M.C.，A.克雷洛夫，A.图卡维纳，P.V. Potapov、S. Turubanova、B. Zutta、S. Ifo、B. Margono、F. Stolle 和 R. Moore。 2016。使用陆地卫星数据发出潮湿热带森林干扰警报。环境研究快报，11 (3)',
    },
    {
      label: '更新频率',
      value: '每周更新',
    },
    {
      label: '内容日期',
      value:
        '2021 年 1 月 1 日（GLAD-L 警报自 2015 年以来一直在亚马逊和刚果盆地以及东南亚岛屿的部分国家/地区运行，但 GFW 上没有历史数据）',
    },
    {
      label: '注意事项',
      value:
        '尽管被称为“森林砍伐警报”，但这些警报会检测森林或树木覆盖的干扰。本产品不区分人为干扰和其他干扰类型。如果在人工林内检测到警报（更有可能发生在 GLAD-L 系统中），警报可能表明木材采伐作业，而没有转换为非林地用途。 \n\n使用“毁林”一词是因为这些是潜在的毁林事件，可以进一步调查警报以确定这一点。 \n\n我们不建议使用森林砍伐警报进行全球或区域趋势评估，也不建议使用森林砍伐警报进行面积估计。我们建议使用年度树木覆盖损失数据来更准确地比较森林随时间变化的趋势，并进行面积估计。最近的警报将包括尚未提高置信度并最终可能被删除的误报。如果在 6 个月内进行额外的无障碍卫星观测之前，冠层快速关闭，则过去的警报可能会被错误地从数据库中删除。此外，方法的更新、系统数量的不同（在综合警报的情况下）以及月和年之间云量的变化给使用森林砍伐警报进行年间/年内比较带来了额外的风险。 \n\n可以“策划”警报来识别用户感兴趣的警报，例如可能是森林砍伐并且可能优先采取行动的警报。用户可以通过覆盖其他上下文数据集（例如保护区或种植的树木）来做到这一点。此处提供非整理数据，以便用户可以定义自己的优先级方法。 “值得关注的地点”数据层中提供了精选的警报位置。 \n\n虽然 Landsat 8 和 9 卫星（以前称为 Landsat 7 和 8）的重访期总计为 8 天，但云层覆盖可能会限制图像的可用性，特别是在雨季。警报日期代表检测的实例，尽管由于持续的云层覆盖，树木覆盖损失可能会更早发生，甚至可能提前几周。请注意，GLAD-L 警报以前源自 Landsat 7 图像，该图像存在已知的扫描线问题，有时会导致误报警报，直到 2023 年 4 月输入切换到 Landsat 9 为止。 \n\n\n在此数据集中，“树木覆盖率”被定义为所有高度大于 5 米、树冠覆盖率大于 60% 的植被，可能采取天然林或人工林的形式。 “树木覆盖损失”表示树冠减少至少半个像素，可能是由于多种因素造成的，包括机械采伐、火灾、疾病或风暴破坏。因此，“损失”并不等于森林砍伐。 \n\n在最初开发警报系统的秘鲁，作者评估数据有 13.5% 的误报（在没有发生的情况下检测到损失），尽管大多数误报 (9.5%) 发生在空地边缘。在边缘，30 m 的陆地卫星像素显示了森林和其他土地覆盖的混合，这使得它们在系统中很容易出错。仅考虑高置信度警报时，误报率降至 1%。该数据有 33% 的漏报（发生损失时未被发现），尽管其中大多数发生在次生林中，这可能是因为该算法是为了捕获原始森林损失而创建的。与误报相比，误报率较高也表明警报是对实际发生的树木覆盖损失的保守估计。 \n\n随着源数据的更新，置信水平可能会追溯改变；在 180 天内或从数据集中删除 4 个观测值后尚未变为高可信度的警报 \n\n一旦警报像素达到高置信度，就不会再在该位置检测到森林损失。 \n\n缩小时，该数据层会显示一定程度的不准确性，因为数据点必须折叠才能在更大的比例下可见。放大查看更多细节。',
    },
    {
      label: '许可证',
      value: '抄送4.0',
    },
  ],
  overview: {
    label: '概览',
    value:
      '该数据集由马里兰大学 GLAD（全球土地分析与发现）实验室创建并得到全球森林观察的支持，是第一个基于 Landsat 的树木覆盖损失警报系统。虽然大多数现有的损失警报产品使用 250 米分辨率的 MODIS 图像，但这些警报具有 30 米的分辨率，因此可以在更精细的空间尺度上检测损失。这些警报的分辨率为 30 米，适用于南北纬 30 度之间的陆地区域。 \n\n新的 Landsat 8 和 9 图像在在线发布时被下载，评估云覆盖或不良数据质量，并与前三年的 Landsat 衍生指标（包括红色、红外和短波波段的排名、平均值和回归，以及 NDVI、NBR 和 NDWI 的排名）进行比较。这些指标和最新的陆地卫星图像通过七个决策树运行，以计算森林干扰的中值概率。概率 >50% 的像素被报告为树木覆盖损失警报。整个过程在Google Earth Engine中运行，以确保可靠的更新和可扩展性。有关方法的更多信息，请参阅《环境研究快报》中的论文。 \n\n在四个连续观察中的两个或多个被标记为树木覆盖损失之前，警报不会被归类为高置信度。如果警报未分类为高置信度，则连续四次观察或超过 180 天后，警报将从数据集中删除。您可以选择在菜单中仅查看高置信度警报，但请记住，仅使用高置信度警报会错过树木覆盖损失的最新检测。',
  },
  citation: {
    label: '引用',
    value:
      '显示这些数据时请使用以下信用： \n\n资料来源：GLAD/UMD，通过全球森林观察获取 \n\n引用这些数据时请使用以下信用： \n\n汉森，M.C.，A.克雷洛夫，A.图卡维纳，P.V. Potapov、S. Turubanova、B. Zutta、S. Ifo、B. Margono、F. Stolle 和 R. Moore。 2016。使用陆地卫星数据发出潮湿热带森林干扰警报。环境研究快报，11 (3)。于[日期]通过全球森林观察访问。 www.globalforestwatch.org',
  },
};
